import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getGameDetails } from './store/selectors/getGameDetails';
import GameDetails from './components/GameDetails';

const GameDetailsDataContainer = () => {
    const gameDetails = useSelector(getGameDetails);

    return (
        <GameDetails {...gameDetails} />
    );
};

GameDetailsDataContainer.propTypes = {
    linescore: PropTypes.object
};

export default GameDetailsDataContainer;
